<template>
    <div class="flex items-center px-4 relative overflow-y-visible">
        <div v-if="showQuantityLabel" class="font-bold mr-4">{{$t('QUANTITY_SELECTOR_SHORT')}}</div>
        <multiselect
            :class="['absolute border border-gray-300 rounded-md max-w-[62px] h-[42px]',
                     isOpen && 'z-50'
            ]"
            :max-height="maxHeight"
            v-model="selectedValue"
            @open="$emit('open')"
            @close="$emit('close')"
            :options="options"
            :searchable="searchable"
            :show-labels="false"
            :allowEmpty="false"
            placeholder=""
            :open-direction="openDirection || null"
        >
            <span slot="noResult"></span>
        </multiselect>
    </div>
</template>

<script>
    export default {
        components: {},
        props: {
            maxHeight: {
                type: Number,
                required: false,
            },
            showQuantityLabel: {
                type: Boolean,
                default: true,
            },
            openDirection: {
                type: String,
                required: false,
            },
            isOpen: {
                type: Boolean,
                default: false,
            },
            value: {
                type: Number,
                default: 1,
            },
            min: {
                type: Number,
                default: 1,
            },
            max: {
                type: Number,
                default: 1,
            },
            searchable: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                selectedValue: this.value,
                isOpenQuantitySelector: false,
            };
        },
        computed: {
            options() {
                const options = [];

                for (let i = this.min; i <= this.max; i += 1) {
                    options.push(i);
                }

                return options;
            },
        },
        watch: {
            value() {
                this.selectedValue = this.value;
            },

            selectedValue() {
                this.$emit('select', this.selectedValue);
            },
        },
    };
</script>
